import { render, staticRenderFns } from "./StandardProjectForm.vue?vue&type=template&id=f342cffe&scoped=true"
import script from "./StandardProjectForm.vue?vue&type=script&setup=true&lang=js"
export * from "./StandardProjectForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./StandardProjectForm.vue?vue&type=style&index=0&id=f342cffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f342cffe",
  null
  
)

export default component.exports